import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function PlanRowSkeleton({ isMobile }) {
    return (
        <Paper
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                p: 2,
                width: '100%',
                ...(!isMobile && { maxWidth: 800, margin: '0 auto' }),
                border: '1px solid, rgba(0, 0, 0, 0.12)',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
            }}
        >
            {/* Header: Avatar + Title + Chip */}
            <Box sx={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: 2, mb: 0.5 }}>
                <Skeleton variant="circular" animation="wave" width={40} height={40} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                        <Skeleton variant="rounded" animation="wave" width={isMobile ? 180 : 220} height={20} />
                        {!isMobile && (
                            <Skeleton variant="rounded" animation="wave" width={100} height={16} />
                        )}
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Skeleton variant="rounded" animation="wave" width={60} height={24} sx={{ borderRadius: 3 }} />
                        {!isMobile && (
                            <>
                                <Skeleton variant="rounded" animation="wave" width={140} height={16} />
                                <Skeleton variant="rounded" animation="wave" width={80} height={16} />
                            </>
                        )}
                    </Stack>
                </Box>
            </Box>

            {/* Mobile: date + expiration rows */}
            {isMobile && (
                <Box sx={{ ml: 7, mb: 0.5 }}>
                    <Skeleton variant="rounded" animation="wave" width={160} height={16} sx={{ mb: 0.75 }} />
                    <Skeleton variant="rounded" animation="wave" width={80} height={16} />
                </Box>
            )}

            <Divider />

            {/* Action buttons */}
            <Stack direction="row" justifyContent="center" spacing={1} sx={{ mt: 0.5 }}>
                <Skeleton variant="rounded" animation="wave" width={110} height={36} />
                <Skeleton variant="rounded" animation="wave" width={110} height={36} />
                {!isMobile && (
                    <>
                        <Skeleton variant="rounded" animation="wave" width={140} height={36} />
                        <Skeleton variant="rounded" animation="wave" width={140} height={36} />
                    </>
                )}
            </Stack>
        </Paper>
    );
}

export function PlansPageSkeleton() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const count = isMobile ? 3 : 4;

    return (
        <Container maxWidth="md" sx={{ py: isMobile ? 2 : 8, px: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {Array.from({ length: count }, (_, i) => (
                    <PlanRowSkeleton key={i} isMobile={isMobile} />
                ))}
            </Box>
        </Container>
    );
}
